/** Session carryover: public checker -> Contract Tools (short-lived). */
export const CONTRACT_TEXT_CARRYOVER_KEY = 'ih_contract_tools_text_v1';
export const CARRYOVER_MAX_AGE_MS = 60 * 60 * 1000;

export function saveContractTextForCarryover(text) {
  try {
    const trimmed = typeof text === 'string' ? text.trim() : '';
    if (!trimmed || typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(
      CONTRACT_TEXT_CARRYOVER_KEY,
      JSON.stringify({ text: trimmed, at: Date.now() }),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function readAndClearContractTextCarryover() {
  try {
    if (typeof sessionStorage === 'undefined') return '';
    const raw = sessionStorage.getItem(CONTRACT_TEXT_CARRYOVER_KEY);
    sessionStorage.removeItem(CONTRACT_TEXT_CARRYOVER_KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.text !== 'string' || typeof parsed.at !== 'number') return '';
    if (Date.now() - parsed.at > CARRYOVER_MAX_AGE_MS) return '';
    return parsed.text;
  } catch {
    return '';
  }
}
